import {Navigate, Outlet} from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const SuperAdminRoute = () => {
    const {user} = useAuth();
    return user?.role === "SUPER_ADMIN" ? <Outlet/> : <Navigate to="/dashboard" replace/>;
};

export default SuperAdminRoute;
